import './index.css';

const ViewCookerCalifications = ({ handleClick }) => {
    return (
        <p className="view-cooker-califications" onClick={handleClick}>View cooker califications</p>
    )
}

export default ViewCookerCalifications;